import { type ConfluenceDatabaseUpdateCommandProperties } from '@atlassian/rovo-content-bridge-api-commands';

import { DatabaseStreamState } from '../database-stream-state';
import { sendDatabaseAIFCExperienceTrackingToParent } from '../metrics/rovo-bridge-database-metrics';

const streamState = DatabaseStreamState.getInstance();

export const editDatabase = async (
  params: ConfluenceDatabaseUpdateCommandProperties,
  contentId: string
) => {
  try {
    if (params.isStreamComplete) {
      // await needed to ensure snapshot is taken after all tokens are processed
      await streamState.completeStreaming();
      streamState.scheduleActionedEvaluation(contentId, 'edit');
      sendDatabaseAIFCExperienceTrackingToParent({
        status: 'success',
        experienceName: 'aiMateAifcAllDataHandled',
        contentId,
      });
      return;
    }

    if (!streamState.isStreamingActive) {
      sendDatabaseAIFCExperienceTrackingToParent({
        status: 'success',
        experienceName: 'aiMateAifcInitialDataReceived',
        contentId,
      });
      streamState.startStreaming(contentId, params.groupId, {
        operationType: 'edit',
      });
    }

    streamState.processChunk(params.data.document);
  } catch (possibleError) {
    const error =
      possibleError instanceof Error ? possibleError : new Error(String(possibleError));
    sendDatabaseAIFCExperienceTrackingToParent({
      status: 'fail',
      error,
      experienceName: 'aiMateAifcAllDataHandled',
      contentId,
    });
    throw error;
  }
};
